// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3ypih","title":"AfterBackImages_title__RzLEb","images":"AfterBackImages_images__1Hp8b"};